import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IGrid from '@meronex/icons/fi/FiGrid';

import AddItemCategoryDialog from './AddItemCategoryDialog';
import EditItemCategoryDialog from './EditItemCategoryDialog';
import ItemCategoriesList from './ItemCategoriesList';
import TopHeader from '../../../views/components/TopHeader';

import { itemCategoriesMng } from '../api/itemCategoriesMng';

function ItemCategoriesDialog(props) {
  const { open, onClose } = props;

  const [openAddItemCategory, setOpenAddItemCategory] = React.useState(false);
  const [openEditItemCategory, setOpenEditItemCategory] = React.useState(false);
  const [selectedItemCategory, setSelectedItemCategory] = React.useState();
  const [itemCategories, setItemCategories] = React.useState();

  const getItemCategories = async () => {
    const itemCategories = await itemCategoriesMng.getItemCategories();
    setItemCategories(itemCategories);
  };

  React.useEffect(() => {
    getItemCategories();
  }, []);

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <TopHeader
          title={'Item Categories'}
          onClose={onClose}
          icon={<IGrid size={20} />}
          actionLabel={'Add Category'}
          onAction={() => {
            setSelectedItemCategory(false);
            setOpenAddItemCategory(true);
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0px' }}>
        <ItemCategoriesList
          itemCategories={itemCategories}
          onEdit={(itemCategory) => {
            setSelectedItemCategory(itemCategory);
            setOpenEditItemCategory(true);
          }}
          onDelete={getItemCategories}
        />
      </DialogContent>
      {openAddItemCategory && (
        <AddItemCategoryDialog
          open={openAddItemCategory}
          onAdd={getItemCategories}
          onClose={() => {
            setOpenAddItemCategory(false);
            setSelectedItemCategory(null);
          }}
        />
      )}
      {openEditItemCategory && (
        <EditItemCategoryDialog
          open={openEditItemCategory}
          itemCategory={selectedItemCategory}
          onEdit={getItemCategories}
          onClose={() => {
            setOpenEditItemCategory(false);
            setSelectedItemCategory(false);
          }}
        />
      )}
    </Dialog>
  );
}

ItemCategoriesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ItemCategoriesDialog;
